import React from "react";

const VectorCoconutTree = (props: React.SVGProps<SVGSVGElement>) => {
    // Helper to generate a realistic feathered leaf path
    // cx, cy: start point (trunk tip)
    // qx, qy: control point for the curve
    // ex, ey: end point (leaf tip)
    const renderFeatheredLeaf = (qx: number, qy: number, ex: number, ey: number, color: string, strokeColor: string, delay: string) => {
        return (
            <g className="tree-leaf" style={{ animationDelay: delay }}>
                {/* Central Rib (Gân lá) */}
                <path d={`M0 0 Q${qx} ${qy} ${ex} ${ey}`} stroke={strokeColor} strokeWidth="2" fill="none" opacity="0.6" />

                {/* Solid Feathered Silhouette - High Density Leaflets */}
                <path
                    d={`M0 0 
                       Q${qx * 0.2} ${qy * 0.2 + 5} ${ex * 0.2 - 5} ${ey * 0.2 + 10} L${ex * 0.2} ${ey * 0.2} 
                       Q${qx * 0.4} ${qy * 0.4 + 8} ${ex * 0.4 - 8} ${ey * 0.4 + 15} L${ex * 0.4} ${ey * 0.4}
                       Q${qx * 0.6} ${qy * 0.6 + 10} ${ex * 0.6 - 10} ${ey * 0.6 + 20} L${ex * 0.6} ${ey * 0.6}
                       Q${qx * 0.8} ${qy * 0.8 + 12} ${ex * 0.8 - 12} ${ey * 0.8 + 25} L${ex * 0.8} ${ey * 0.8}
                       Q${qx} ${qy + 15} ${ex} ${ey + 30} L${ex} ${ey}
                       Q${qx} ${qy - 5} 0 0 Z`}
                    fill={color}
                    stroke={strokeColor}
                    strokeWidth="0.5"
                />

                {/* Additional Leaflet Detail Strokes */}
                <g stroke={strokeColor} strokeWidth="0.8" opacity="0.4">
                    <path d={`M${ex * 0.3} ${ey * 0.3} L${ex * 0.3 - 8} ${ey * 0.3 + 12}`} />
                    <path d={`M${ex * 0.5} ${ey * 0.5} L${ex * 0.5 - 12} ${ey * 0.5 + 18}`} />
                    <path d={`M${ex * 0.7} ${ey * 0.7} L${ex * 0.7 - 15} ${ey * 0.7 + 22}`} />
                    <path d={`M${ex * 0.9} ${ey * 0.9} L${ex * 0.9 - 10} ${ey * 0.9 + 15}`} />
                </g>
            </g>
        );
    };

    return (
        <svg
            width="300"
            height="500"
            viewBox="0 0 300 500"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            {/* Trunk - Detailed with "Vân" (Rings) and Texture */}
            <g transform="translate(0, 140)">
                {/* Base Shadow & Roots */}
                <path d="M85 340 Q110 335 135 340 L130 330 Q110 325 90 330 Z" fill="#5D4037" opacity="0.4" />

                {/* Grass Patches at the base (Chân thật hơn) */}
                <g transform="translate(85, 315)">
                    {/* Darker blades */}
                    <path d="M0 25 L5 10 L10 25 M30 25 L35 5 L40 25 M55 25 L60 12 L65 25" fill="#1B5E20" />
                    {/* Main Green blades */}
                    <path d="M-5 25 L2 15 L10 25 M15 25 L22 8 L30 25 M40 25 L48 12 L55 25 M65 25 L72 18 L80 25" fill="#2E7D32" />
                    {/* Highlights */}
                    <path d="M8 25 L12 18 L16 25 M45 25 L50 15 L55 25" fill="#4CAF50" />
                </g>

                {/* Main Trunk Shape */}
                <path d="M110 340 C110 270 120 210 145 110" stroke="#8D6E63" strokeWidth="16" strokeLinecap="round" fill="none" />
                <path d="M110 340 C110 270 120 210 145 110" stroke="#A1887F" strokeWidth="12" strokeLinecap="round" fill="none" opacity="0.4" />

                {/* Horizontal Rings (Vân) - Integrated perfectly */}
                <g stroke="#4E342E" strokeWidth="1.8" opacity="0.6">
                    <path d="M102 320 Q110 322 118 320" />
                    <path d="M104 300 Q112 302 120 300" />
                    <path d="M106 280 Q114 282 122 280" />
                    <path d="M108 260 Q116 262 124 260" />
                    <path d="M110 240 Q118 242 126 240" />
                    <path d="M114 220 Q122 222 130 220" />
                    <path d="M118 200 Q126 202 134 200" />
                    <path d="M123 180 Q131 182 139 180" />
                    <path d="M128 160 Q136 162 144 160" />
                    <path d="M134 140 Q142 142 150 140" />
                    <path d="M140 125 Q148 127 156 125" />
                </g>
            </g>

            {/* Leaves Group - Ultra-Realistic High Density Fronds */}
            <g transform="translate(145, 210)">
                {/* Render 12 high-detail feathered leaves for a lusher canopy (Đẹp hơn) */}
                {renderFeatheredLeaf(-40, 30, -80, 80, "#1B5E20", "#0D2A10", "0s")}  {/* Bottom Left far */}
                {renderFeatheredLeaf(-60, 10, -110, 40, "#2E7D32", "#1B5E20", "-0.8s")} {/* Mid Left */}
                {renderFeatheredLeaf(-70, -30, -120, -20, "#388E3C", "#2E7D32", "-1.5s")} {/* Top Left */}
                {renderFeatheredLeaf(-30, -70, -50, -110, "#43A047", "#2E7D32", "-2.2s")} {/* Center Top Left */}

                {/* New middle layers for thickness */}
                {renderFeatheredLeaf(-10, -80, 0, -130, "#2E7D32", "#1B5E20", "-3.1s")}
                {renderFeatheredLeaf(20, -75, 50, -120, "#388E3C", "#2E7D32", "-1.4s")}

                {renderFeatheredLeaf(40, -70, 20, -120, "#1B5E20", "#0D2A10", "-0.5s")} {/* Center Top Right */}
                {renderFeatheredLeaf(80, -50, 120, -40, "#388E3C", "#2E7D32", "-1.2s")} {/* Top Right */}
                {renderFeatheredLeaf(100, 0, 140, 50, "#2E7D32", "#1B5E20", "-1.9s")}  {/* Mid Right */}
                {renderFeatheredLeaf(70, 50, 60, 110, "#1B5E20", "#0D1A10", "-2.6s")} {/* Bottom Right */}

                {/* Additional lower branches for volume */}
                {renderFeatheredLeaf(-20, 50, -40, 90, "#1B5E20", "#0D1A10", "-3.5s")}
                {renderFeatheredLeaf(30, 40, 45, 85, "#2E7D32", "#1B5E20", "-0.2s")}
            </g>

            {/* Coconuts Cluster */}
            <g transform="translate(145, 210)">
                <circle cx="-6" cy="10" r="11" fill="#4E342E" stroke="#3E2723" strokeWidth="1.5" />
                <circle cx="-9" cy="7" r="3" fill="#FFF" opacity="0.15" />

                <circle cx="10" cy="5" r="12" fill="#5D4037" stroke="#3E2723" strokeWidth="1.5" />
                <circle cx="7" cy="2" r="3.5" fill="#FFF" opacity="0.15" />

                <circle cx="2" cy="18" r="10" fill="#3E2723" stroke="#261A16" strokeWidth="1.5" />
                <circle cx="-1" cy="15" r="3" fill="#FFF" opacity="0.15" />
            </g>
        </svg>
    );
};

export default VectorCoconutTree;
